import { CreateAgendaRequest, EditAgendaRequest } from "@shared/dtos/requests/practiceRequests.dto"
import { AgendaResponse } from "@shared/dtos/responses/appointmentResponses.dto"
import { AgendaCreationResponse } from "@shared/dtos/responses/practiceResponses.dto"
import { HisAgendaOptionResponse } from "@shared/zod/schemas/responses/appointment"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

/** The HIS agendas an agenda can be linked to, with the roles to pre-select for each. */
export const hisAgendaOptions = (practiceId: string): Promise<HisAgendaOptionResponse[]> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendas/hisnames`,
    method: "get",
  }).then((resp) => resp.data)
}

export const getAll = (practiceId: string): Promise<AgendaResponse[]> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendas`,
    method: "get",
  }).then((resp) => resp.data)
}

export const create = (practiceId: string, req: CreateAgendaRequest): Promise<AgendaCreationResponse> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendas`,
    method: "post",
    data: req,
  }).then((resp) => resp.data)
}

export const edit = (practiceId: string, agendaId: string, req: EditAgendaRequest): Promise<void> => {
  return axiosAuth({
    url: `/practices/${practiceId}/agendas/${agendaId}`,
    method: "patch",
    data: req,
  }).then(() => undefined)
}

export const remove = (practiceId: string, agendaId: string): Promise<void> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendas/${agendaId}`,
    method: "delete",
  }).then(() => undefined)
}
